import { Typography } from "@mui/material";
import { Error } from "@mui/icons-material";
import { tss } from "tss-react";
import { panelBackgroundColor } from "styles/common";

const useStyles = tss.create({
    root: {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        backgroundColor: panelBackgroundColor,
    },
    icon: {
        width: 56,
        height: 56,
        color: "red",
    },
});
const ErrorMessage = (props: { message?: string }) => {
    const { classes } = useStyles();
    var { message } = props;
    if (!message) {
        message = "401 Unauthorised authentication failure";
    }
    return (
        <div className={classes.root}>
            <div>
                <Error className={classes.icon} />
            </div>
            <div>
                <Typography>{message}</Typography>
            </div>
        </div>
    );
};

export default ErrorMessage;
